/**
 * Mega Menu Controller
 * Handles hover delays, accessibility, and interactions for the mega menu.
 */
class MegaMenu {
  constructor() {
    this.navItems = document.querySelectorAll('.tw-header__nav-item');
    this.delay = 150; // Delay in ms before opening/closing
    this.timers = new Map();
    this.init();
  }

  init() {
    this.navItems.forEach(item => {
      const link = item.querySelector('.tw-header__nav-link');
      const dropdown = item.querySelector('.tw-header__dropdown');

      if (!dropdown) return;

      // Desktop Hover Logic
      item.addEventListener('mouseenter', () => this.handleMouseEnter(item));
      item.addEventListener('mouseleave', () => this.handleMouseLeave(item));

      // Accessibility - Focus
      link.addEventListener('focus', () => this.openItem(item));
      
      // Close on Escape
      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.closeAll();
      });
    });

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.tw-header__nav-item')) {
        this.closeAll();
      }
    });
  }

  handleMouseEnter(item) {
    if (this.timers.has(item)) {
      clearTimeout(this.timers.get(item));
      this.timers.delete(item);
    }

    const timer = setTimeout(() => {
      this.closeAllExcept(item);
      this.openItem(item);
    }, this.delay);

    this.timers.set(item, timer);
  }

  handleMouseLeave(item) {
    if (this.timers.has(item)) {
      clearTimeout(this.timers.get(item));
      this.timers.delete(item);
    }

    const timer = setTimeout(() => {
      this.closeItem(item);
    }, this.delay);

    this.timers.set(item, timer);
  }

  openItem(item) {
    item.classList.add('is-active');
    const dropdown = item.querySelector('.tw-header__dropdown');
    if (dropdown) {
      dropdown.setAttribute('aria-hidden', 'false');
    }
  }

  closeItem(item) {
    item.classList.remove('is-active');
    const dropdown = item.querySelector('.tw-header__dropdown');
    if (dropdown) {
      dropdown.setAttribute('aria-hidden', 'true');
    }
  }

  closeAllExcept(activeItem) {
    this.navItems.forEach(item => {
      if (item !== activeItem) this.closeItem(item);
    });
  }

  closeAll() {
    this.navItems.forEach(item => this.closeItem(item));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new MegaMenu();
});
